<script>
import { VRow } from 'vuetify/lib';
import { VCol } from 'vuetify/lib';
export default {
  functional: true,
  props: {
    'no-flex': Boolean,
    cols: Array,
    center: Boolean,
    noMargin: Boolean,
    reducedMargin: Boolean
  },
  render(createElement, context) {
    const slots = context.slots().default || [];
    if (slots.length == 0) return;

    const cols = context.props.cols;
    function getProps(slot, index) {
      return slot?.data?.attrs?.cols
        ? { cols: slot.data.attrs.cols }
        : cols && cols[index]
        ? { cols: cols[index] }
        : {};
    }

    const rowTag = context.props.noFlex ? 'div' : VRow;
    const colTag = context.props.noFlex ? 'div' : VCol;

    return createElement(
      rowTag,
      {
        class: {
          'b-row': true,
          'b-row--no-flex': context.props.noFlex,
          ...context.data.staticClass
        },
        style: context.data.staticStyle,
        props: { noGutters: true }
      },
      slots
        .filter(slot => slot.tag)
        .map((slot, index) =>
          createElement(
            colTag,
            {
              class: [
                'b-row__element',
                { 'b-row__element--center': context.props.center },
                { 'b-row__element--noMargin': context.props.noMargin },
                { 'b-row__element--reducedMargin': context.props.reducedMargin },
              ],
              props: getProps(slot, index)
            },
            [slot]
          )
        )
    );
  }
};
</script>

<style lang="scss" scoped>
.b-row {
  margin-left: -16px;
  display: flex;
  margin-top: -16px;

  &--no-flex {
    flex: 0 0 auto;
  }

  &__element {
    padding-left: 16px;
    margin-top: 16px;
    &--center {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    &--noMargin {
      margin: 0;
    }
    &--reducedMargin {
      margin-top: 8px;
    }
  }
}
</style>